const getSupplierNSCorNPI = ({ business, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }

  return business['Company Identify'] && business['Company Identify']['Practice NPI'] ? business['Company Identify']['Practice NPI'] : null;
};

export default getSupplierNSCorNPI;



// WEBPACK FOOTER //
// ./src/utils/print/getSupplierNSCorNPI.js